(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function () {
            function initLatestReviewsWidget() {
                if (typeof Swiper === 'undefined') {
                    return;
                }

                var swipers = document.querySelectorAll('.js-latest-reviews-swiper');
                if (!swipers.length) {
                    return;
                }

                Array.prototype.forEach.call(swipers, function (swiperElement) {
                    if (swiperElement.dataset.inited === '1') {
                        return;
                    }

                    new Swiper(swiperElement, {
                        direction: 'horizontal',
                        setWrapperSize: true,
                        spaceBetween: 0,
                        slidesPerView: 2.1,
                        grabCursor: true,
                        watchOverflow: true,
                        centerInsufficientSlides: true,
                        breakpoints: {
                            360: { slidesPerView: 1.2 },
                            390: { slidesPerView: 1.3 },
                            450: { slidesPerView: 1.2 },
                            480: { slidesPerView: 1.3 },
                            550: { slidesPerView: 1.5 }
                        }
                    });

                    swiperElement.dataset.inited = '1';
                });
            }

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', initLatestReviewsWidget);
            } else {
                initLatestReviewsWidget();
            }
        })();
    }, {}] }, {}, [1]);